import { useMemo } from 'react';
import { css } from '@emotion/react';
import { Button, color, typography } from '@uniquegood/realworld-studio-design';
import { useHistory } from 'react-router-dom';

function CheckoutFail() {
  const history = useHistory();

  const query = useMemo(() => new URLSearchParams(window.location.search), []);
  const message = query.get('message') || '결제 중 오류가 발생했습니다.';
  const planType = query.get('planType');

  const handleRetry = () => {
    if (planType) {
      history.push(`/checkout/${planType}/select-channel`);
    } else {
      history.push('/pricing');
    }
  };

  const handleGoHome = () => {
    history.push('/');
  };

  return (
    <div css={mainContainer}>
      <div css={failIcon}>✕</div>
      <div css={titleWrap}>결제 실패</div>
      <div css={messageWrap}>{message}</div>
      <div css={buttonGroup}>
        <Button type="primary" onClick={handleRetry} cssStyle={buttonStyle}>
          다시 시도하기
        </Button>
        <Button onClick={handleGoHome} cssStyle={buttonStyle}>
          홈으로 가기
        </Button>
      </div>
    </div>
  );
}

export default CheckoutFail;

const mainContainer = css`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 58px);
  padding: 24px;
`;

const failIcon = css`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: ${color.palette_status_red_tint_04};
  color: ${color.palette_status_red_100};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  font-weight: ${typography.weight.bold};
  margin-bottom: 24px;
`;

const titleWrap = css`
  font-size: 24px;
  font-weight: ${typography.weight.bold};
  margin-bottom: 16px;
  color: ${color.text_default};
`;

const messageWrap = css`
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 32px;
  text-align: center;
  color: ${color.text_subdued};
  white-space: pre-line;
`;

const buttonGroup = css`
  display: flex;
  gap: 12px;
  flex-direction: column;
  width: 100%;
  max-width: 300px;
`;

const buttonStyle = css`
  width: 100%;
`;
